'use client';

import {
  ModalDialog,
  Modal,
  ModalOverlay,
  Button,
  CloseButton,
  Input,
  TextArea
} from '@goodneighbor/ui';
import useInviteAFriendModal from '@/hooks/useInviteAFriendModal';
import styles from './inviteAFriendModal.module.scss';

type InviteAFriendModalProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  eventId: string;
};

export default function InviteAFriendModal({
  isOpen,
  onOpenChange,
  eventId
}: InviteAFriendModalProps) {
  const {
    subject,
    message,
    handleSubjectChange,
    handleMessageChange,
    handleOpenChange,
    mailtoHref
  } = useInviteAFriendModal({
    eventId,
    onOpenChange
  });

  return (
    <ModalOverlay
      className={styles.overlay}
      isDismissable
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
    >
      <Modal>
        <ModalDialog>
          <div className={styles.inviteModal}>
            <div className={styles.header}>
              <h1 className={styles.title}>Invite a Friend</h1>
              <CloseButton size="lg" onClick={() => handleOpenChange(false)} />
            </div>
            <div className={styles.content}>
              <Input
                label="Email Subject"
                type="text"
                placeholder="Let's volunteer together."
                value={subject}
                onChange={handleSubjectChange}
              />
              <TextArea
                label="Email Message"
                value={message}
                onChange={handleMessageChange}
                rows={5}
              />
            </div>
            <div className={styles.footer}>
              <Button
                className={styles.sendButton}
                size="lg"
                color="primary"
                href={mailtoHref}
                target="_blank"
              >
                Send invitation
              </Button>
            </div>
          </div>
        </ModalDialog>
      </Modal>
    </ModalOverlay>
  );
}
